import { useNavigate, useParams } from '@solidjs/router'
import { type JSX, Show, createEffect, createMemo, on } from 'solid-js'
import { authStore } from '../../stores/auth.store'
import { workspaceStore } from '../../stores/workspace.store'

interface WorkspaceRouteGuardProps {
  children: JSX.Element
}

export function WorkspaceRouteGuard(props: WorkspaceRouteGuardProps) {
  const params = useParams<{ workspaceSlug: string }>()
  const navigate = useNavigate()

  createEffect(
    on(
      () => params.workspaceSlug,
      (workspaceSlug) => {
        if (workspaceSlug && workspaceStore.workspace?.slug !== workspaceSlug) {
          workspaceStore.fetchWorkspace()
          workspaceStore.fetchUsage()
        }
      }
    )
  )

  const needsWorkspaceList = createMemo(
    () =>
      authStore.state.isAuthenticated &&
      authStore.state.userType === 'hiring_manager' &&
      workspaceStore.workspaces.length === 0
  )

  createEffect(() => {
    if (needsWorkspaceList()) {
      workspaceStore.fetchWorkspaces()
    }
  })

  const isValidWorkspace = createMemo(() => {
    const list = workspaceStore.workspaces
    if (list.length === 0) {
      return true
    }
    return list.some((w) => w.slug === params.workspaceSlug)
  })

  createEffect(() => {
    const list = workspaceStore.workspaces
    if (list.length > 0 && !list.some((w) => w.slug === params.workspaceSlug)) {
      const defaultSlug = workspaceStore.defaultWorkspaceSlug
      if (defaultSlug) {
        navigate(`/app/w/${defaultSlug}/dashboard`, { replace: true })
      } else {
        navigate('/app/w/create', { replace: true })
      }
    }
  })

  return <Show when={isValidWorkspace()}>{props.children}</Show>
}
